import { authorizedInstance } from "../config/axios"
import { buildQueryString } from "../utils"

// The endpoint's wire param is `perPage`, but every other hook/component in
// this app speaks `page`/`limit` via usePagination() — translate once here
// rather than renaming the shared hook convention.
export const getCustomerSuccessTickets = async ({
  page,
  limit,
  filters = {},
}) => {
  const query = buildQueryString({
    page,
    perPage: limit,
    patientIssuerName: filters.patientIssuerName,
    accessionNo: filters.accessionNo,
    trackingTicketStatus: filters.trackingTicketStatus,
    customerSatisfactionStatus: filters.customerSatisfactionStatus,
    startDate: filters.startDate,
    endDate: filters.endDate,
  })

  const response = await authorizedInstance.get(
    `/customer-success-tickets?${query}`
  )

  return response.data
}

export const getCustomerSuccessTicketStats = async ({ filters = {} } = {}) => {
  const query = buildQueryString({
    patientIssuerName: filters.patientIssuerName,
    accessionNo: filters.accessionNo,
    startDate: filters.startDate,
    endDate: filters.endDate,
  })

  const response = await authorizedInstance.get(
    `/customer-success-tickets/stats?${query}`
  )

  return response.data // { total, trackingStatusCounts, customerSatisfactionStatusCounts, centers }
}

export const getCustomerSuccessCenters = async ({
  page,
  limit,
  filters = {},
}) => {
  const query = buildQueryString({
    page,
    perPage: limit,
    centerName: filters.centerName,
    status: filters.status,
  })

  const response = await authorizedInstance.get(
    `/customer-success-tickets/centers?${query}`
  )

  return response.data // { data, total, page, perPage } — data[].Cases[] nested
}
